<template>
  <div>
    <van-nav-bar
      to="StuList"
      :title="this.stuname+' 详细信息'"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-form @submit="onSubmit">
      <van-field
        readonly
        clickable
        name="gradeid"
        :value="gradeValue"
        label="年级"
        placeholder="点击选择年级"
        @click="showGradePicker = true"
      />
      <van-popup v-model="showGradePicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="gradeColumns"
          @confirm="gradeOnConfirm"
          @cancel="showGradePicker = false"
          :default-index="0"
        />
      </van-popup>

      <van-field
        clearable
        v-model="stuname"
        name="stuname"
        label="姓名"
        placeholder="姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
        clearable
        v-model="stunum"
        type="number"
        name="stunum"
        label="学号"
        placeholder="学号"
        :rules="[{ required: true, message: '请填写学号' }]"
      />
      <van-field
        clearable
        v-model="classes"
        type="text"
        name="classes"
        label="班级"
        placeholder="班级"
        readonly
        @click="classesShow=true"
        :rules="[{ required: true, message: '请填写班级' }]"
      />
      <van-field
        readonly
        clickable
        name="school"
        :value="schoolValue"
        label="学院(部)"
        placeholder="点击选择学院(部)"
        @click="showSchoolPicker = true"
      />
      <van-popup v-model="showSchoolPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="schoolColumns"
          @confirm="schoolOnConfirm"
          @cancel="showSchoolPicker = false"
          :default-index="0"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        name="campusArea"
        :value="campusAreaValue"
        label="校区"
        placeholder="点击选择校区"
        @click="showCampusAreaPicker = true"
      />
      <van-popup v-model="showCampusAreaPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="campusAreaColumns"
          @confirm="campusAreanConfirm"
          @cancel="showCampusAreaPicker = false"
          :default-index="0"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        name="level"
        :value="levelValue"
        label="学历层次"
        placeholder="点击选择学历层次"
        @click="showLevelPicker = true"
      />
      <van-popup v-model="showLevelPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="levelColumns"
          @confirm="levelOnConfirm"
          @cancel="showLevelPicker = false"
          :default-index="0"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        name="gender"
        :value="genderValue"
        label="性别"
        placeholder="点击选择性别"
        @click="showGenderPicker = true"
      />
      <van-popup v-model="showGenderPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="genderColumns"
          @confirm="genderOnConfirm"
          @cancel="showGenderPicker = false"
          :default-index="0"
        />
      </van-popup>
      <van-cell title="上次修改时间" :value="lastModifiedTime"/>
      <div style="margin: 16px;">
        <van-button round block type="warning" native-type="submit">
          修改学生信息
        </van-button>
      </div>
    </van-form>

    <van-divider/>

    <van-cell-group>
      <van-cell v-for="(item,index) in FailStudentList" :title="item.sName+' '+item.gender+' '+item.sNum" value="失败"
                :key="index"/>
    </van-cell-group>

    <van-action-sheet v-model="classesShow" title="班级搜索">
      <div class="classesContent">
        <van-search v-model="classesSearchKey" @search="classesSearch" placeholder="请输入不少于两个汉字班级搜索关键词"/>
        <van-cell-group inset>
          <van-cell :class="item.value==classes?'classesSelected':''" @click="classes=item.value,classesShow=false"
                    :title="item.value" :value="item.key" v-for="(item,index) in classesSearchValues" :key="index"/>
        </van-cell-group>
      </div>
    </van-action-sheet>

  </div>
</template>

<script>
import Vue from 'vue';
import {
  NavBar,
  Form,
  Field,
  Button,
  Picker,
  Popup,
  Divider,
  Dialog,
  Uploader,
  CellGroup,
  Cell,
  ActionSheet,
  Search,
  Toast, Sticky
} from 'vant';
import {ModifyStudent, ClassesSearchByKey} from "@/network/student";
import {LoginUnbind} from "@/network/publics";

Vue.use(NavBar);
Vue.use(Form);
Vue.use(Field);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Button);
Vue.use(Divider);
Vue.use(Dialog);
Vue.use(Uploader);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(ActionSheet);
Vue.use(Search);
Vue.use(Toast);
Vue.use(Sticky);

export default {
  name: "StuDetail",
  data() {
    return {
      stuname: '',
      stunum: '',
      classes: '',
      classesSearchKey: '',
      classesSearchValues: [],
      gradeValue: '',
      genderValue: '',
      levelValue: '',
      schoolValue: '',
      campusAreaValue: '',
      school: '',
      lastModifiedTime: '',
      genderColumns: ['男', '女'],
      levelColumns: ['本科', '专科', '专升本'],
      schoolColumns: ['工学部', '艺体学部', '医学部','商学部', '医学部', '商学部', '国际学院', '外国语学院', '应用技术学院', '职业技术学院'],
      gradeColumns: ['2021', '2020', '2019', '2018', '2017', '2016', '2000'],
      campusAreaColumns: ['南校区','济源校区'],
      showGenderPicker: false,
      showLevelPicker: false,
      showSchoolPicker: false,
      showCampusAreaPicker: false,
      classesShow: false,
      showGradePicker: false,
    }
  },
  activated() {
    this.gradeValue = this.$route.query.gId;
    this.stuname = this.$route.query.sName;
    this.stunum = this.$route.query.sNum;
    this.classes = this.$route.query.classes;
    this.schoolValue = this.$route.query.school;
    this.campusAreaValue = this.$route.query.campusArea;
    this.levelValue = this.$route.query.level;
    this.genderValue = this.$route.query.gender;
    this.lastModifiedTime = new Date(this.$route.query.createDate).toLocaleString();


    const grade = this.GLOBAL.grade;
    this.gradeColumns = [];
    for (let i = 0; i < 5; i++) {
      this.gradeColumns.push(grade - i);
    }
  },
  methods: {
    onClickLeft() {
      this.$router.replace("StuList");
    },
    classesSearch() {
      const key = this.classesSearchKey;
      if (key.length < 2) {
        Toast('请输入不少于两个汉字班级搜索关键词');
        return
      }
      ClassesSearchByKey(key).then(res => {
        this.classesSearchValues = res;
      }).catch(res => {
        this.Dialoginfo('提示', '添加失败');
      })
    },
    onSubmit(values) {
      Dialog.confirm({
        title: '提示',
        message: '确定要修改' + values.stuname + '信息吗'
      }).then(() => {


        if (values.gender === "") {
          this.Dialoginfo('提示', '性别不能为空');
        } else if (values.school === "") {
          this.Dialoginfo('提示', '学院(部)不能为空');
        } else if (values.level === "") {
          this.Dialoginfo('提示', '学历层次不能为空');
        } else if (values.gradeid === "") {
          this.Dialoginfo('提示', '年级不能为空');
        } else {
          ModifyStudent(this.$route.query.id, values.gradeid, values.stunum, values.stuname, values.gender, values.classes, values.school, values.level,values.campusArea).then(res => {
            if (res) {
              this.Dialoginfo('提示', '修改成功');
              this.lastModifiedTime=new Date().toLocaleString();
            } else {
              this.Dialoginfo('提示', '修改失败');
            }
          }).catch(res => {
            this.Dialoginfo('提示', '修改失败');
          })
        }  // on confirm
      })
    },
    genderOnConfirm(value) {
      this.genderValue = value;
      this.showGenderPicker = false;
    },
    levelOnConfirm(value) {
      this.levelValue = value;
      this.showLevelPicker = false;
    }, schoolOnConfirm(value) {
      this.schoolValue = value;
      this.showSchoolPicker = false;
    },campusAreanConfirm(value) {
      this.campusAreaValue = value;
      this.showCampusAreaPicker = false;
    },
    gradeOnConfirm(value) {
      this.gradeValue = value;
      this.showGradePicker = false;
    },
    Dialoginfo(title, message) {
      Dialog.alert({
        title,
        message
      }).then(() => {
        // on close
      });
    },
  }
}
</script>

<style scoped>
.classesContent {
  padding: 16px 16px 360px;
}

.classesSelected {
  color: #7dbfff;
  font-weight: bold;
}
</style>
